import { render, staticRenderFns } from "./Gudang.vue?vue&type=template&id=489ba330&"
import script from "./Gudang.vue?vue&type=script&lang=js&"
export * from "./Gudang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports